__turbopack_context__.v({
  "alias-to-delete": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__alias-to-delete",
  "buttons": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__buttons",
  "cancel-button": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__cancel-button",
  "delete-btn": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__delete-btn",
  "deletion-button": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__deletion-button",
  "dialog-wrapper": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__dialog-wrapper",
  "hero": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__hero",
  "left-content": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__left-content",
  "permanence-warning": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__permanence-warning",
  "prefix-error-icon": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__prefix-error-icon",
  "underlay": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__underlay",
  "warning-wrapper": "AliasDeletionButtonPermanent-module-scss-module__WujWwG__warning-wrapper",
});
